import styled from 'styled-components';

export const StyledBadge = styled.div<{ charLength: number }>`
  display: inline-block;
  background: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ charLength }) => (charLength * 2) + 7}px;
  font-size: 12px;
  font-weight: bold;
  min-width: 16px; 
  height: 16px;
  box-sizing: border-box;
  text-align: center;
  line-height: 1.17;
  box-sizing: border-box;
`;

export const StyledBadgeText = styled.span<{ charLength: number }>`
  display: inline-block;
  padding: ${({ charLength }) => {
    if (charLength === 1) {
      return '0';
    }
    return '0 4px';
  }};
  position: relative;
  top: 1px;
`;
